import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./scss/seller-dashboard.scss";
import Icon from "../lib/icon";
import ManagerFooter from "../components/ManagerFooter";
import api from "../api";
import SellerOrderCard from "../components/SellerOrderCard";
import Pagination from "../components/Pagination";

const TAKE = 5;

export default function SellerDashboardPage() {
  const navigate = useNavigate();
  const [balance] = useState(0);

  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const pages = Math.ceil(total / TAKE);

  const load = async (pageNumber = 1) => {
    const skip = (pageNumber - 1) * TAKE;

    const { data } = await api.get("/api/seller/orders", {
      params: { skip, take: TAKE }
    });

    setOrders(
      data.orders.map(o => ({
        id: o.id,
        orderNumber: o.orderNumber,
        status: o.status,
        price: o.price,
        date: new Date(o.dateCreate).toLocaleDateString("ru-RU", {
          day: "numeric",
          month: "long"
        }),
        productCount: o.productCount,
        images: o.images || []
      }))
    );

    setTotal(data.total);
    setPage(pageNumber);
  };

  useEffect(() => {
    load(1);
  }, []);

  return (
    <>
      <div className="seller-dashboard">

        {/* BALANCE */}
        <div className="seller-dashboard__balance">
          <div className="seller-dashboard__balance-text">
            Личный кабинет{/*Баланс: {balance.toLocaleString("ru-RU")} ₽*/}
          </div>

          <div className="seller-dashboard__balance-actions">
            <button onClick={() => {navigate("/seller/setting")}}>
              <Icon name="settings" />
            </button>

            <button onClick={() => navigate("/seller/login")}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4ZM16.2929 7.29289C16.6834 6.90237 17.3166 6.90237 17.7071 7.29289L21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L17.7071 16.7071C17.3166 17.0976 16.6834 17.0976 16.2929 16.7071C15.9024 16.3166 15.9024 15.6834 16.2929 15.2929L18.5858 13H11C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H18.5858L16.2929 8.70711C15.9024 8.31658 15.9024 7.68342 16.2929 7.29289Z" fill="#A1233C"/>
              </svg>
            </button>
          </div>
        </div>

        {/* ACTION CARDS */}
        <div className="seller-dashboard__actions">

          <div
            className="seller-dashboard__card"
            onClick={() => navigate("/seller/market")}
          >
            <div className="seller-dashboard__card-icon">
              <Icon name="briefcase" color="#D62F50" />
            </div>
            <div className="seller-dashboard__card-text">
              Магазин
              <span>›</span>
            </div>
          </div>

          <div
            className="seller-dashboard__card"
            onClick={() => navigate("/seller/products")}
          >
            <div className="seller-dashboard__card-icon">
              <Icon name="cart" color="#D62F50" />
            </div>
            <div className="seller-dashboard__card-text">
              Товары
              <span>›</span>
            </div>
          </div>

          <div
            className="seller-dashboard__card seller-dashboard__card--wide"
            onClick={() => navigate("/seller/requisites")}
          >
            <div className="seller-dashboard__card-icon">
              <Icon name="wallet" color="#D62F50" />
            </div>
            <div className="seller-dashboard__card-text">
              Реквизиты для вывода
              <span>›</span>
            </div>
          </div>

        </div>

        {/* ORDERS */}
        <div className="seller-dashboard__orders">
          <div className="seller-dashboard__orders-title">
            Заказы
          </div>

          <div className="seller-dashboard__orders-list">
            {orders.map(order => (
              <SellerOrderCard key={order.id} order={order} />
            ))}
          </div>

          <Pagination
            page={page}
            pages={pages}
            onChange={(p) => load(p)}
          />
        </div>

      </div>
      <ManagerFooter />
    </>
  );
}